<template>
    <div class="position-relative p-2">
        <div class="d-block d-sm-flex justify-content-sm-end">
            <search-customer-contact-submission-input @searchChange="onSearchChange"/>
        </div>
        <b-table
            :fields="table.fields"
            :items="customer_contact_submissions.data"
            :thead-class="'contact-submission-thead'"
            empty-text="No data."
            hover
            ref="table"
            responsive
            show-empty
            v-loading="customer_contact_submissions.loading"
            />
        <pagination
            v-if="customer_contact_submissions.meta"
            :pagination="customer_contact_submissions.meta"
            @current-change="onPageChange"
            />
    </div>
</template>

<script>
import CustomerContactSubmission from "@/models/customer-contact-submission";
import SearchCustomerContactSubmissionInput from "@/components/main/customer-enquiry/custom/SearchCustomerContactSubmissionInput";

export default {
    components: {
        SearchCustomerContactSubmissionInput
    },
    data() {
        return {
            table: {
                fields: [
                    {
                        key: 'name',
                        label: 'Name'
                    },
                    {
                        key: 'email',
                        label: 'Email'
                    },
                    {
                        key: 'phone',
                        label: 'Phone'
                    },
                    {
                        key: 'message',
                        label: 'Message'
                    },
                ]
            },
            customer_contact_submissions: {
                data: [],
                meta: null,
                loading: false,
            },
            search_by: null,
            search_query: null
        }
    },
    created() {
        this.getData({});
    },
    methods: {
        getData({page = 1}) {
            this.customer_contact_submissions.loading = true;
            let query = CustomerContactSubmission.page(page)

            if (this.search_by && this.search_query) {
                query.where(this.search_by, this.search_query);
            }

            query.get()
                .then(response => {
                    this.customer_contact_submissions.data = response.data;
                    this.customer_contact_submissions.meta = response.meta;
                })
                .finally(() => this.customer_contact_submissions.loading = false);
        },
        onPageChange(page) {
            this.getData({page})
        },
        onSearchChange({search_by, search_query}) {
            this.search_by = search_by;
            this.search_query = search_query;
            this.getData({});
        }
    }
}
</script>

<style>
.contact-submission-thead {
  background-color: #15A9F0;
  color: #FFFFFF;
}
</style>
